module.exports = "/_next/static/images/6e00848d165a8bacb40119fcdabdf862-rewards-app-md@2x.png";